import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { FartherAccountId, LocalDate, TriggerRunId, } from "../../Types";
import ValidationError from "../../ZodError";
export const TriggerRunStatus = z.enum([
    "planned",
    "user_canceled",
    "run_started",
    "run_completed",
    "error",
]);
const FundingTransfer = z.object({
    accountId: FartherAccountId,
    transferAmount: z.number(),
});
export const TriggerRun = z.object({
    id: TriggerRunId,
    planDate: LocalDate,
    executeDate: LocalDate,
    status: TriggerRunStatus,
    transfers: z.array(FundingTransfer),
});
const Response = z.array(TriggerRun).optional();
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/cash-cycle/v1/client/${clientId}/trigger-run`
    : `https://middleware.uat.farther.com/cash-cycle/v1/client/${clientId}/trigger-run`;
export default async function getTriggerRuns(clientId, config) {
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getTriggerRuns] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getTriggerRuns.js.map